export default {"src":"/_next/static/media/icon-sanctuary-chronomerge.190214c0.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};